const readmoreOnClick = (target) => {
  if (target) {
    target.addEventListener('click', (ev) => {
      let newTarget = document.querySelector(target.dataset.target)
      if (newTarget && !newTarget.classList.contains('is-open')) {
        target.classList.toggle('is-rotated')
        newTarget.classList.toggle('is-open')
      }
    })
  } else {
    console.warn('Toggle Read More: No target given')
  }
}

const initReadmore = () => {
  const readmoreEls = document.querySelectorAll('.js-read-more')
  if (readmoreEls) {
    Array.from(readmoreEls, target => readmoreOnClick(target))
  }
}

export { initReadmore }